const signatures: { [key: string]: string } = {
  'application/pdf': '25504446',
};

const checkFileType = (file: File, acceptFileTypes: Array<string>): Promise<any> =>
  new Promise((resolve: Function) => {
    let validFileType;
    if ((window as any).FileReader && window.Blob) {
      const fileReader = new FileReader();
      // @ts-ignore
      fileReader.onloadend = ({ target: { result } }) => {
        const byteArray = new Uint8Array(result).subarray(0, 4);
        let header = '';
        byteArray.forEach((byte) => {
          header += byte.toString(16);
        });

        let signature = '';
        acceptFileTypes.forEach((type) => {
          if (!signature && type === file.type) {
            signature = signatures[type];
          }
        });

        if (signature) {
          validFileType = signature === header;
        } else {
          validFileType = acceptFileTypes.includes(file.type);
        }
        resolve(validFileType);
      };
      fileReader.readAsArrayBuffer(file);
    } else {
      validFileType = acceptFileTypes.includes(file.type);
      resolve(validFileType);
    }
  });

export default checkFileType;
